import React from 'react';
import { Device } from "../typings";

interface Props {
    device: Device;
}

function DeviceRow({ device }: Props) {
    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 3}}>{device.id}</div>
            <div className="drill-row-item" style={{flex: 1}}>{device.operatingSystem}</div>
            <div className="drill-row-item" style={{flex: 1}}>{device.registered?.split(' ')[0]}</div>
            <div className="drill-row-item" style={{flex: 1}}>{device.status ? 'ACTIVE' : 'INACTIVE'}</div>
            <div className="drill-row-item" style={{flex: 3}}>{device.owner}</div>
        </div>
    );
}

export default DeviceRow;
